import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { getCurrentUser } from "../api/user/GetCurrentUser";
import LocalStorage from "../helper/Generic/LocalStorage";
import { loginUser, logoutUser } from "../Redux/user/user";
import { loadDefaultSelections } from "../helper/Generic/LoadDefaultSelections";
import { isMobile } from "react-device-detect";

const MOBILE_ALLOWED_PATHS = ["/leagues/match_preview", "/userprofile"];

const ProtectedRoute = ({ redirectPath = "/login", user }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const authToken = LocalStorage.getAuthenticationToken();
  const [checkingAuth, setCheckingAuth] = useState(true);


  useEffect(() => {
    if (!authToken) {
      setCheckingAuth(false);
      return;
    }

    getCurrentUser(
      (response) => {
        dispatch(loginUser(response.data.user));

        // Held open until this resolves so the user's preferred seasons/cups are
        // in the store before any page mounts and picks its menu selection.
        loadDefaultSelections(dispatch, () => setCheckingAuth(false));

        // ✅ DO NOT redirect if already on a route
        if (location.pathname !== "/login") return;

        const target = isMobile
          ? "/leagues/match_preview"
          : "/leagues";

        navigate(
          {
            pathname: target,
            search: location.search,
          },
          { replace: true }
        );
      },
      () => {
        dispatch(logoutUser());
        setCheckingAuth(false);
        navigate(redirectPath, { replace: true });
      }
    );
  }, []);


  if (checkingAuth) {
    return null; // or spinner
  }

  if (user == null) {
    return (
      <Navigate to={redirectPath} state={{ backTo: `${location.pathname}` }} replace />
    );
  }

  if (user) {
    if (isMobile && !MOBILE_ALLOWED_PATHS.includes(location.pathname)) {
      return <Navigate to="/leagues/match_preview" replace />;
    }
    return <Outlet />;
  }

};

export default ProtectedRoute;
